/**
 * 알림 관련 아이콘 컴포넌트
 */
import { Bell, ShoppingBag, Gift, AlertCircle, Clock, X } from 'lucide-react';
import { type NotificationType } from './types';

/**
 * 알림 타입에 따른 아이콘 반환
 */
export function NotificationIcon({ type }: { type: NotificationType }) {
  switch (type) {
    case 'order':
      return <ShoppingBag className="h-4 w-4 text-primary" />;
    case 'promotion':
      return <Gift className="h-4 w-4 text-secondary" />;
    case 'system':
      return <AlertCircle className="h-4 w-4 text-warning" />;
    default:
      return <Bell className="h-4 w-4 text-muted-foreground" />;
  }
}

/**
 * 시계 아이콘
 */
export function TimeIcon({ className = 'h-3 w-3' }: { className?: string }) {
  return <Clock className={className} />;
}

/**
 * 닫기 아이콘
 */
export function CloseIcon({ className = 'h-4 w-4' }: { className?: string }) {
  return <X className={className} />;
}

/**
 * 알림 없음 아이콘
 */
export function EmptyIcon({ className = 'h-12 w-12' }: { className?: string }) {
  return <Bell className={`${className} text-muted-foreground mx-auto mb-3 opacity-50`} />;
}
